import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import React from 'react'
import ReactDOM from 'react-dom/client'
// import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { persistor, store } from './app/core/store'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import App from './App'
import Loader from 'app/shared/layouts/loader/Loader'
import { CommonUIProvider } from 'app/shared/context/CommonUIProvider'
import { VerifyPage } from 'app/shared/context/VerifyPage'
import ObzenTracker from 'ObzenTracker'
import { LoadMenu } from 'app/shared/context/LoadMenu'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={Loader()} persistor={persistor}>
                <BrowserRouter>
                    <React.Suspense fallback={<Loader />}>
                        <ObzenTracker />
                        <CommonUIProvider>
                            <VerifyPage>
                                <App />
                            </VerifyPage>
                        </CommonUIProvider>
                    </React.Suspense>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
